import React, { useContext } from 'react';
import { PoseGroup } from 'react-pose';
import {
  ModalBlock,
  Modalfilm,
  ModalIcontBlock,
  ModalContent,
  ModalTextBlock,
  ModalButtonBlock,
  IconImg,
} from '../../style/ModalStyle';
import Button from '../Button';
import Fonts from '../Fonts';
import { AppContext } from '../../context/app';

import icon from '../../asset/all/fail.svg';

export default ({ message, handlHide }) => {
  const { t } = useContext(AppContext);
  return (
    <PoseGroup>
      {message && (
        <ModalBlock key="ModalBlock">
          <Modalfilm
            onClick={() => {
              handlHide();
            }}
          />
          <ModalContent>
            <ModalIcontBlock>
              <IconImg src={icon} style={{ width: 94 }} />
            </ModalIcontBlock>
            <ModalTextBlock>
              <Fonts
                text={message}
                fontSize={18}
                fontWeight="bold"
                color="#333333"
              />
            </ModalTextBlock>
            <ModalButtonBlock>
              <Button
                type="primary"
                onClick={() => {
                  handlHide();
                }}
              >
                <Fonts text={t(['ok'])} fontSize={12} color="#fff" />
              </Button>
            </ModalButtonBlock>
          </ModalContent>
        </ModalBlock>
      )}
    </PoseGroup>
  );
};
